import BackendUtil from '../utils/backend.util';

export const get = async () => {
  const { success, body, error } = await BackendUtil.request.get("/beacons");
  return success ? { success, payload: body } : { success, error };
};